export const optinLabels = Object.freeze({
  optin: "Optin",
  optout: "Optout",
  neverOptin: "Never optin",
})